import * as React from "react"
export const Svg_059 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path fill="url(#b)" d="M59 27.12v-6.834h-5.762v11.287L59 27.12Z" />
      <path
        fill="url(#c)"
        d="M26.197 21.016 29.5 19.39l3.303 1.626-.525-3.644 2.566-2.639-3.628-.626-1.716-3.256-1.716 3.256-3.628.626 2.567 2.64-.526 3.643Z"
      />
      <path fill="url(#d)" d="M59 56.482V31.489L43.751 43.276 59 56.483Z" />
      <path
        fill="url(#e)"
        d="M18.621 44.93 2.373 59h54.254L40.38 44.93H18.621Z"
      />
      <path fill="url(#f)" d="M5.762 20.286H0v6.833l5.762 4.454V20.286Z" />
      <path fill="url(#g)" d="M0 31.489v24.993l15.249-13.206L0 31.49Z" />
      <path
        fill="url(#h)"
        d="M18.567 41.472h21.866l9.348-7.226V0H9.22v34.246l9.348 7.226Zm1.77-29.588 5.181-.894 2.453-4.652h3.058l2.452 4.652 5.182.894.945 2.91-3.666 3.769.75 5.205-2.474 1.798-4.718-2.323-4.718 2.322-2.474-1.797.75-5.205-3.666-3.77.944-2.909ZM41.6 31.052v3.457H17.458v-3.457H41.6Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={54.571}
        x2={60.458}
        y1={21.979}
        y2={26.843}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={26.628}
        x2={31.344}
        y1={12.375}
        y2={20.402}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={47.278}
        x2={60.551}
        y1={35.238}
        y2={48.344}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={14.919}
        x2={17.254}
        y1={47.04}
        y2={61.612}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={1.332}
        x2={7.22}
        y1={21.979}
        y2={26.843}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={3.526}
        x2={16.8}
        y1={35.238}
        y2={48.344}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="h"
        x1={18.599}
        x2={38.491}
        y1={6.221}
        y2={37.708}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h59v59H0z" />
      </clipPath>
    </defs>
  </svg>
)